import { paymentReferenceTypes } from 'client/Interfaces/Draft/FieldsInterface'
import { IInvoiceTimelineEventTypes } from 'client/Interfaces/Invoice/InvoiceEventsInterface'

import { CustomerInterface } from '../../Interfaces/CustomerInterface'
import { OrderInterface } from '../../Interfaces/OrderInterface'

export interface InvoiceSummaryInterface {
  localCurrency: string
  foreignCurrency: string
  localTaxTotal: number
  localNetTotal: number
  localGrossTotal: number
  foreignTaxTotal?: number
  foreignNetTotal?: number
  foreignGrossTotal: number
  reductionTotal?: number
  workTotal?: number
  localReductionTotal?: number
  localWorkTotal?: number
  foreignReductionTotal?: number
  foreignWorkTotal?: number
  exchangeRate: number
}

export enum InvoiceStatus {
  DRAFT = 'draft',
  OPEN = 'open',
  SENT = 'sent',
  PAID = 'paid',
  OVERDUE = 'overdue',
  DELETED = 'deleted',
  IN_COLLECTION = 'in_collection',
  REMINDED = 'reminded',
  IN_FINANCING = 'in_financing',
  IS_AGERAS_VERSION = 'is_ageras_version',
}

export enum InvoiceSecondaryStatus {
  RECEIVED_FOR_PROCESSING = 'received_for_processing',
  DELAYED = 'delayed',
  FAILED_INVALID_CONTENT = 'failed_invalid_content',
  FAILED = 'failed',
  FAILED_REJECTED = 'failed_rejected',
  DELIVERED = 'delivered',
}

export enum InvoiceVersion {
  AGERAS = 'ageras',
  ZERVANT = 'zervant',
  MOBILE = 'mobile',
}

export interface DocumentEvent {
  eventType?: string
  eventData?: any
  createdAt: string
}

export interface InvoiceListItemInterface {
  id: number
  invoiceNumber: string
  creditNoteNumber: string
  externalId: number
  externalInvoiceId: number
  externalCreditNoteId: number
  issueDate: string
  dueDate: string
  title: string
  currency: string
  referenceNumber: string
  paymentReferenceType: paymentReferenceTypes.ISO | paymentReferenceTypes.SPY_BE | paymentReferenceTypes.SPY_FI
  summary: InvoiceSummaryInterface
  customer: {
    displayName: string
    firstName?: string
    lastName?: string
    email?: string
    id: number
    customerType: CustomerInterface['customerType']
    address?: { country: string }
  }
  lines?: any[]
  order?: OrderInterface | null
  version?: InvoiceVersion | null
  status: {
    paidDate?: string
    status: InvoiceStatus
    secondaryStatus?: InvoiceSecondaryStatus | null
    events?: IInvoiceTimelineEventTypes[]
  }
  __typename?: 'creditNote' | 'invoiceDraft' | 'invoice'
}
